import {
  AssignmentModalInitialData,
  SetStaffingProjectData,
  StaffingAssignmentListMember,
  StaffingProjectAssignment,
  StaffingProjectData,
} from 'domain/shared/staffing';
import { Tooltip } from 'framework/ui/mui-builder';
import React, { useState } from 'react';
import { useShowContext } from 'framework/show';
import UpdateDeleteStaffingAssignmentModal from './UpdateDeleteStaffingAssignmentModal';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import IconButton from '@mui/material/IconButton';
import { AssignmentType } from 'domain/shared/assignment';

const UpdateAssignmentAction = ({
  projectData,
  setProjectData,
  isVirtual,
  disabled,
}: {
  projectData: StaffingProjectData;
  setProjectData?: SetStaffingProjectData;
  isVirtual?: boolean;
  disabled?: boolean;
}) => {
  const { data } = useShowContext();
  const member = data.getData() as unknown as StaffingAssignmentListMember;

  const [open, setOpen] = useState(false);
  const currentAssignment = (projectData.assignments || []).find(
    (assignment: StaffingProjectAssignment) => String(assignment.id) === String(member.assignmentId),
  ) as (StaffingProjectAssignment & { minPercent?: number }) | undefined;

  return (
    <>
      <Tooltip title={`Update ${isVirtual ? 'planned' : ''} assignment`}>
        <span>
          <IconButton
            onClick={() => {
              setOpen(prev => !prev);
            }}
            sx={{ p: 0 }}
            disabled={disabled}
          >
            <AppRegistrationIcon color="primary" />
          </IconButton>
        </span>
      </Tooltip>
      <UpdateDeleteStaffingAssignmentModal
        open={open}
        setOpen={setOpen}
        isVirtual={isVirtual}
        projectData={projectData}
        setProjectData={setProjectData}
        initialData={
          {
            id: member.assignmentId,
            assignmentType: AssignmentType.INDIVIDUAL_ASSIGNMENT,
            employeeId: currentAssignment?.employeeAlias ?? member.employeeId,
            slotId: currentAssignment?.slotId ?? member.slotId,
            membershipRole: currentAssignment?.membershipRole ?? member.membershipRole,
            positionId: currentAssignment?.positionId ?? member.positionId,
            technologyId: currentAssignment?.technologyId ?? member.technologyId,
            competencyLevel: currentAssignment?.competencyLevel ?? member.competencyLevel,
            minPercent: currentAssignment?.minPercent ?? member.minPercent,
            maxPercent: currentAssignment?.maxPercent ?? member.maxPercent,
            backup: currentAssignment?.isBackup ?? member.backup,
            bench: currentAssignment?.isBench ?? member.bench,
            from: currentAssignment?.fromDate ?? member.from,
            to: currentAssignment?.toDate ?? member.to,
            noteText: currentAssignment?.noteText ?? member.noteText,
          } satisfies AssignmentModalInitialData
        }
      />
    </>
  );
};

export default UpdateAssignmentAction;
